export default "/images/shipro.svg?0ab371f51729d8608076089f209b8a94";